import Picker from "@/components/picker/mobile-picker";
import { PickerDivider } from "@/components/picker/mobile-picker/picker-divider";
import { FilledButton } from "@/components/ui/buttons/FilledButton";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo, useMemo, useState } from "react";

export type GoalOption = { value: string; name: string };

interface GoalSelectModalProps {
  defaultValue: string;
  options: GoalOption[];
  onSelect: (value: string) => void;
}

export const GoalSelectModal = memo(function GoalSelectModal({
  defaultValue,
  options,
  onSelect,
}: GoalSelectModalProps) {
  const [tempValue, setTempValue] = useState<string | undefined>();

  const pickerValue = useMemo(
    () => ({
      goal: tempValue ?? defaultValue ?? options[0]?.value ?? "lose-weight",
    }),
    [tempValue, defaultValue, options],
  );

  return (
    <div className="p-9 space-y-3">
      <h3 className={textVariants.title3 + " text-center"}>Your Goal</h3>

      <div className="relative">
        <PickerDivider itemHeight={64} />
        <Picker
          value={pickerValue}
          onChange={(val) => setTempValue(val.goal as string)}
          wheelMode="natural"
          itemHeight={64}
          showDivider={false}
          height={64 * 3}
        >
          <Picker.Column name="goal">
            {options.map((option) => (
              <Picker.Item key={option.value} value={option.value}>
                {({ selected }) => (
                  <div
                    className={cn(
                      "text-center h-16 flex items-center justify-center opacity-50",
                      {
                        [textVariants.title1]: !selected,
                        [textVariants.largeTitle]: selected,
                        "text-black font-semibold opacity-100": selected,
                      },
                    )}
                  >
                    {option.name}
                  </div>
                )}
              </Picker.Item>
            ))}
          </Picker.Column>
        </Picker>
      </div>

      <FilledButton
        color="purple"
        text="Confirm Goal"
        onClick={() => onSelect(pickerValue.goal as string)}
      />
    </div>
  );
});
